"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldSubheadingClassName = exports.fieldHeadingClassName = exports.inputStyle = exports.inputClassName = exports.fieldContainerStyle = exports.fieldContainerClassName = exports.formClassName = exports.maxWidth = void 0;
exports.maxWidth = 400;
exports.formClassName = 'flex-container flex-dir-column align-middle space-y-10';
exports.fieldContainerClassName = 'width-100 space-y-2 padding-horizontal-6';
exports.fieldContainerStyle = { maxWidth: exports.maxWidth };
exports.inputClassName = 'border-brownish-grey margin-0';
exports.inputStyle = { borderWidth: 1, borderRadius: 10 };
exports.fieldHeadingClassName = 'text-lg text-center font-semibold';
exports.fieldSubheadingClassName = 'text-sm text-center';
